import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'

import { listAuditLog } from './api'
import type { AuditFilter } from './types'

export function auditLogQueryOptions(tenantId: string, filter: AuditFilter) {
  return queryOptions({
    queryKey: [
      'audit',
      tenantId,
      filter.actorType,
      filter.correlationId,
      filter.fromDate,
      filter.toDate,
      filter.page,
    ] as const,
    queryFn: () => listAuditLog(tenantId, filter),
    // Ao paginar/filtrar, mantem a pagina anterior visivel para nao piscar (UX estavel).
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })
}

export function useAuditLog(tenantId: string | undefined, filter: AuditFilter) {
  return useQuery({
    ...auditLogQueryOptions(tenantId ?? '', filter),
    enabled: tenantId !== undefined,
  })
}
